import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { HEADER_HEIGHT } from '~/core/utils';

const FILTER_WIDTH = 480;
const FILTER_ACTION_HEIGHT = 110; // 46px for button + 32px vertical padding
// 89 is the secondary nav bar, 99 is the top level nav which we want to cover as of now
const Z_INDEX = 100;

export const DialogContainer = styled.div`
    background: ${({ theme }) => theme.Surface.Opposite.primary};
    height: 100vh;
    left: 0;
    opacity: ${({ $isVisible }) => ($isVisible ? 0.5 : 0)};
    position: fixed;
    top: 0;
    width: 100vw;
    transition: opacity 0.5s;
    visibility: ${({ $isVisible }) => ($isVisible ? 'initial' : 'hidden')};
    z-index: ${Z_INDEX};
`;

export const FiltersContainer = styled.dialog`
    background: ${({ theme }) => theme.Surface.primary};
    border: none;
    display: flex;
    flex-direction: column;
    gap: ${BaseStyle.GAP_SIZES.large}px;
    height: 100vh;
    left: ${({ $isVisible }) => ($isVisible ? 0 : '100vw')};
    max-height: initial;
    max-width: initial;
    padding: 32px 16px ${FILTER_ACTION_HEIGHT + 16}px 16px;
    position: fixed;
    top: 0;
    transition: left 0.5s;
    width: 100vw;
    z-index: ${Z_INDEX + 1};

    ${BaseStyle.Mixins.screenSizes.medium} {
        border: solid 1px ${({ theme }) => theme.Surface.border};
        box-shadow: ${BaseStyle.Mixins.utility.fadedBoxShadow};
        height: calc(100vh - ${HEADER_HEIGHT}px);
        left: ${({ $isVisible }) => ($isVisible ? `calc(100vw - ${FILTER_WIDTH}px)` : '100vw')};
        padding: 32px 32px ${FILTER_ACTION_HEIGHT + 16}px 32px;
        top: ${HEADER_HEIGHT}px;
        width: ${FILTER_WIDTH}px;
    }
`;

export const FilterHeader = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;

    svg {
        cursor: pointer;
        font-size: 36px;
    }
`;

export const FilterActionContainer = styled.div`
    ${BaseStyle.Mixins.gaps.large};
    align-items: center;
    background: ${({ theme }) => theme.Surface.primary};
    bottom: 0;
    ${BaseStyle.Mixins.utility.boxShadow(16, 'rgba(0, 0, 0, 0.15)', [BaseStyle.StyleDirections.up])};
    display: flex;
    height: ${FILTER_ACTION_HEIGHT}px;
    justify-content: center;
    margin-left: ${({ $isVisible }) => ($isVisible ? '-16px' : 0)};
    padding: 16px;
    position: fixed;
    width: inherit;

    ${BaseStyle.Mixins.screenSizes.medium} {
        margin-left: ${({ $isVisible }) => ($isVisible ? '-32px' : 0)};
        padding: 32px;
    }
`;
